<!--
 * @Date: 2022-09-26 10:50:19
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-13 10:34:20
 * @description: description
 * 发展历程
-->
<template>
  <div :class="$style.developmentHistory">
    <div :class="$style.historyBlock"></div>
    <div :class="$style.historyDot"></div>
    <!-- <div :class="$style.historyBaseMap"></div> -->
    <div :class="$style.historyTitle">
      {{ info.title }}
    </div>
    <div :class="$style.historyImgBox">
      <img :src="info.cover" alt="" />
    </div>
  </div>
</template>
<script>

export default {
  name: 'aboutus-development-history',
  props: {
    info: Object
  }

}
</script>

<style lang="scss" module>
.developmentHistory {
  box-sizing: border-box;
  position: relative;
  width: 1200px;
  // height: 810px;
  margin: 0 auto;
  padding-top: 120px;
  text-align: center;

  .historyBlock {
    position: absolute;
    left: -360px;
    top: -10px;
    z-index: 9;
    width: 446px;
    height: 446px;
    background-image: url("../../../assets/img/aboutus/pc/development.history/block-bg.png");
    background-size: 100% 100%;
  }

  .historyDot {
    position: absolute;
    left: 442px;
    top: 76px;
    z-index: 9;
    width: 109px;
    height: 44px;
    background-image: url("../../../assets/img/aboutus/pc/development.history/history-dot.png");
    background-size: 100% 100%;
  }

  // .historyBaseMap {
  //   position: absolute;
  //   right: -265px;
  //   top: 175px;
  //   z-index: 9;
  //   width: 1394px;
  //   height: 634px;
  //   background-image: url("../../../assets/img/aboutus/pc/development.history/history-base-map.png");
  //   background-size: 100% 100%;
  // }

  .historyTitle {
    height: 45px;
    margin-bottom: 35px;
    text-align: center;
    line-height: 45px;
    font-size: 32px;
    font-weight: 600;
    color: hsl(0, 0%, 20%);
  }

  .historyImgBox {
    position: relative;
    z-index: 99;
    width: 1200px;
    // height: 696px;
    // margin-left: 24px;

    & img {
      display: block;
      width: 100%;
    }
  }
}
</style>
